module.exports = __webpack_public_path__ + "assets/img/team/thomas-wulfrank.jpg";